import {
  getSlotDateLabel,
  getSlotTimeLabel,
  getSlotTimeRangeLabel,
} from './slotDateTime.helpers';

// Joins the locale-aware date and the time without a word, so the combined row
// reads the same in every language (the date and time helpers already localise).
const DATE_TIME_SEPARATOR = ' · ';

/**
 * The appointment as one combined label with the start time, e.g.
 * "Wednesday, 15 July 2026 · 09:00" / "miércoles, 15 de julio de 2026 · 09:00".
 * Takes the slot object; empty when no slot, so the row is dropped rather than
 * drawn blank.
 */
export const getAppointmentLabel = (slot, locale) => {
  if (!slot?.start) {
    return '';
  }
  const date = getSlotDateLabel(slot.start, locale);
  const time = getSlotTimeLabel(slot.start);
  return `${date}${DATE_TIME_SEPARATOR}${time}`;
};

/**
 * The appointment as one combined label with the time window, e.g.
 * "Thursday, 1 October 2026 · 14:00 - 15:30". Used on confirmation, where the
 * booked window is shown. Falls back to the start time alone when the slot has
 * no end, so the row never shows a dangling separator. Empty when no slot.
 */
export const getAppointmentRangeLabel = (slot, locale) => {
  if (!slot?.start) {
    return '';
  }
  if (!slot.end) {
    return getAppointmentLabel(slot, locale);
  }
  const date = getSlotDateLabel(slot.start, locale);
  const range = getSlotTimeRangeLabel(slot.start, slot.end);
  return `${date}${DATE_TIME_SEPARATOR}${range}`;
};
